(function () {
  'use strict';

  var isUpdating = false;

  function page() {
    return document.querySelector('[data-gb-cart-page]');
  }

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.routes && window.routes.rootUrl) || '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  function cartEndpoint(path) {
    return rootUrl() + 'cart' + path;
  }

  function parseError(response, fallback) {
    return response.json().then(function (data) {
      return data.description || data.message || fallback;
    }).catch(function () {
      return fallback;
    });
  }

  function setLoading(loading) {
    isUpdating = loading;
    var element = page();
    if (!element) return;
    element.classList.toggle('is-loading', loading);
    element.setAttribute('aria-busy', loading ? 'true' : 'false');
    element.querySelectorAll('button, input, textarea, a.gb-cart-page__primary').forEach(function (control) {
      if (loading) control.setAttribute('aria-disabled', 'true');
      else control.removeAttribute('aria-disabled');
    });
  }

  function setStatus(message, type) {
    var element = page();
    if (!element) return;
    var status = element.querySelector('[data-gb-cart-page-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', type === 'error');
    status.classList.toggle('is-success', type === 'success');
    status.hidden = !message;
    if (message) status.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function updateCartCount(cart) {
    if (!cart) return;
    var count = Number(cart.item_count || 0);
    document.querySelectorAll('.cart-info em').forEach(function (node) {
      node.textContent = count;
    });
    document.querySelectorAll('.cart-count-mobile').forEach(function (node) {
      node.textContent = count;
      node.hidden = count < 1;
    });
    document.querySelectorAll('.menu-cart').forEach(function (link) {
      link.classList.toggle('animated', count > 0);
      link.classList.toggle('bounce', count > 0);
    });
  }

  function reinitializePaymentButtons() {
    if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
      window.Shopify.PaymentButton.init();
    }
  }

  function replacePage(html) {
    var current = page();
    if (!current) return false;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var replacement = parsed.querySelector('[data-gb-cart-page]');
    if (!replacement) return false;
    current.replaceWith(replacement);
    reinitializePaymentButtons();
    return true;
  }

  function refreshPage() {
    var current = page();
    if (!current) return Promise.reject(new Error('La sezione del carrello non è disponibile.'));
    var sectionId = current.getAttribute('data-section-id');
    var url = cartEndpoint('') + '?section_id=' + encodeURIComponent(sectionId) + '&_=' + Date.now();
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Impossibile aggiornare il carrello.');
      return response.text();
    }).then(function (html) {
      if (!replacePage(html)) throw new Error('La sezione del carrello non è disponibile.');
    });
  }

  function changeQuantity(line, quantity) {
    if (isUpdating) return;
    setLoading(true);
    setStatus('', '');
    fetch(cartEndpoint('/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
    }).then(function (response) {
      if (!response.ok) {
        return parseError(response, 'La quantità richiesta non è disponibile.').then(function (message) {
          throw new Error(message);
        });
      }
      return response.json();
    }).then(function (cart) {
      updateCartCount(cart);
      return refreshPage();
    }).catch(function (error) {
      return refreshPage().catch(function () {}).then(function () {
        setStatus(error.message, 'error');
      });
    }).finally(function () {
      setLoading(false);
    });
  }

  function updateCart(payload, successMessage) {
    if (isUpdating) return;
    setLoading(true);
    setStatus('', '');
    fetch(cartEndpoint('/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        return parseError(response, 'Non è stato possibile aggiornare il carrello.').then(function (message) {
          throw new Error(message);
        });
      }
      return response.json();
    }).then(function (cart) {
      updateCartCount(cart);
      return refreshPage().then(function () {
        if (successMessage) setStatus(successMessage, 'success');
        return cart;
      });
    }).catch(function (error) {
      setStatus(error.message, 'error');
    }).finally(function () {
      setLoading(false);
    });
  }

  function applyDiscount(code) {
    var normalizedCode = String(code || '').trim();
    if (!normalizedCode) {
      setStatus('Inserisci un codice sconto.', 'error');
      return;
    }
    if (isUpdating) return;
    setLoading(true);
    setStatus('', '');
    fetch(cartEndpoint('/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: normalizedCode })
    }).then(function (response) {
      if (!response.ok) {
        return parseError(response, 'Non è stato possibile applicare il codice sconto.').then(function (message) {
          throw new Error(message);
        });
      }
      return response.json();
    }).then(function (cart) {
      updateCartCount(cart);
      var applied = Number(cart.total_discount || 0) > 0 ||
        (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0);
      return refreshPage().then(function () {
        setStatus(
          applied ? 'Codice sconto applicato.' : 'Il codice non è valido per gli articoli presenti nel carrello.',
          applied ? 'success' : 'error'
        );
      });
    }).catch(function (error) {
      setStatus(error.message, 'error');
    }).finally(function () {
      setLoading(false);
    });
  }

  document.addEventListener('click', function (event) {
    var change = event.target.closest('[data-gb-cart-page-change]');
    if (change) {
      event.preventDefault();
      if (change.disabled || change.getAttribute('aria-disabled') === 'true') return;
      changeQuantity(change.dataset.line, change.dataset.quantity);
      return;
    }

    var saveNote = event.target.closest('[data-gb-save-note]');
    if (saveNote) {
      event.preventDefault();
      var note = page() && page().querySelector('[data-gb-cart-note]');
      updateCart({ note: note ? note.value : '' }, 'Nota salvata.');
      return;
    }

    var checkout = event.target.closest('[data-gb-cart-page-checkout]');
    if (checkout) {
      var terms = page() && page().querySelector('[data-gb-cart-terms]');
      if (terms && !terms.checked) {
        event.preventDefault();
        setStatus('Accetta i termini e le condizioni per continuare.', 'error');
        terms.focus();
        return;
      }
      document.dispatchEvent(new CustomEvent('gb:begin-checkout'));
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-gb-cart-page-discount]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('input[name="discount"]');
    applyDiscount(input ? input.value : '');
  });
})();
